__turbopack_context__.v({
  "icon": "RefinerFeedbackButton-module__tL_HQW__icon",
  "label": "RefinerFeedbackButton-module__tL_HQW__label",
  "tab": "RefinerFeedbackButton-module__tL_HQW__tab",
});
